import { render, staticRenderFns } from "./StrapiReglementsCampagneView.vue?vue&type=template&id=655c53e6"
import script from "./StrapiReglementsCampagneView.vue?vue&type=script&lang=js"
export * from "./StrapiReglementsCampagneView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports